export default __webpack_public_path__ + "static/media/Danel Polyakov.c362b837.png";